import { render, staticRenderFns } from "./EleFormButton.vue?vue&type=template&id=a0a35f96&"
import script from "./EleFormButton.vue?vue&type=script&lang=js&"
export * from "./EleFormButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports